import { render } from "./SalesReport.vue?vue&type=template&id=623a3cfa&scoped=true"
import script from "./SalesReport.vue?vue&type=script&lang=js"
export * from "./SalesReport.vue?vue&type=script&lang=js"

import "./SalesReport.vue?vue&type=style&index=0&id=623a3cfa&scoped=true&lang=css"
import "./SalesReport.vue?vue&type=style&index=1&id=623a3cfa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-623a3cfa"]])

export default __exports__